import { Smartphone, MonitorSmartphone, Globe2, CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";

const stack = [
  { icon: Smartphone, label: "Mobile Application Development" },
  { icon: MonitorSmartphone, label: "Web Application Development" },
  { icon: Globe2, label: "Website Development" },
];

export const About = () => (
  <section id="about" className="relative py-20 sm:py-28 lg:py-32" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16 items-center">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-laser">
          // About Dotnet Services
        </span>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6 leading-tight">
          About Dotnet Services
        </h2>
        <div className="space-y-4 text-slate-400 text-base leading-relaxed">
          <p>
            Dotnet Services is a software development company focused on building practical
            digital solutions for businesses, startups, and entrepreneurs.
          </p>
          <p>
            We specialize in mobile application development, web application development, and
            professional website development.
          </p>
          <p>
            Our goal is simple: understand the business problem, design the right solution,
            build it carefully, and help the client launch with confidence.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative rounded-2xl border border-border-subtle bg-card-dark/80 backdrop-blur-xl shadow-2xl shadow-black/40 overflow-hidden">
          <div className="flex items-center gap-1.5 px-4 py-3 border-b border-border-subtle">
            <span className="h-2.5 w-2.5 rounded-full bg-red-500/70" />
            <span className="h-2.5 w-2.5 rounded-full bg-yellow-500/70" />
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-500/70" />
            <div className="ml-3 h-5 flex-1 rounded-md bg-white/5 text-[10px] text-slate-500 flex items-center px-2 font-mono">
              what-we-build.stack
            </div>
          </div>
          <div className="p-6 sm:p-8 space-y-4">
            {stack.map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.label}
                  className="flex items-center gap-4 rounded-xl border border-white/5 bg-white/[0.02] p-4 hover:border-laser/40 transition-colors duration-300"
                >
                  <div className="h-10 w-10 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center shrink-0">
                    <Icon size={20} className="text-laser" />
                  </div>
                  <span className="text-white font-medium text-sm sm:text-base">{item.label}</span>
                  <CheckCircle2 size={18} className="text-emerald-400 ml-auto shrink-0" />
                </div>
              );
            })}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
